/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup MST_003
 * @created at      :   2026/02/10
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    company_cd: '',
    customer_cd: '',
    location_cd: '',
    person_name: '',
    pageSize: 10,
    pageNo: 1
};

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        searchMst003Info(context, param) {
            try {
                const searchParam = {
                    company_cd: param.company_cd ?? '',
                    customer_cd: param.customer_cd ?? '',
                    location_cd: param.location_cd ?? '',
                    person_id: param.person_id ?? '',
                    person_name: param.person_name ?? '',
                    pageNo: param.pageNo ?? 1,
                    pageSize: param.pageSize ?? 10,
                    mode: param.mode ?? 0
                };
                repository.searchMst003Info(searchParam).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const rawList = data.Data?.data ?? [];
                        const listData = rawList.map((item) => {
                            const personId = item.person_id ?? item.rep_person_cd ?? item['個人ID'];
                            const personName =
                                item.person_name ??
                                item.user_name ??
                                item.responsible_person_name ??
                                item['担当者名'] ??
                                `${item.responsible_person_family_name ?? ''} ${item.responsible_person_name ?? ''}`.trim();
                            return {
                                ...item,
                                person_id: personId,
                                person_name: personName
                            };
                        });
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        const paging = data.Data?.paging ?? { total_rows: 0, page: 1, pagesize: searchParam.pageSize };
                        context.commit('setTotalRows', paging);
                    }
                });
            } catch (e) {
                console.log('searchMst003Info: ' + e.message);
            }
        }
    }
};
